import * as actionTypes from "../ActionTypes";
import { put, call, takeLatest, takeEvery } from "redux-saga/effects";
import * as api from "./UsersAPI";
import { actionUpdateGlobalLoaderSagaAction } from "../GlobalLoader/GlobalLoaderAction";
import { getServerMessage } from "../../utils/apiMessage";

function* getRolesRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getRoles, payload);
    action.payload.callback(response);
  } catch (err) {
    const message = getServerMessage(err, "Failed to load roles");
        if (typeof action?.payload?.callback === "function") {
      action.payload.callback({ type: 0, message, data: err?.response?.data });
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* saveCMSUserRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;

    const response = yield call(api.saveCMSUser, payload);
    action.payload.callback(response);
  } catch (err) {
    const message = getServerMessage(err, "Failed to save user details");
        if (typeof action?.payload?.callback === "function") {
      action.payload.callback({ type: 0, message, data: err?.response?.data });
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getCMSUserRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getCMSUser, payload);
    action.payload.callback(response);
  } catch (err) {
    const message = getServerMessage(err, "Failed to load users");
        if (typeof action?.payload?.callback === "function") {
      action.payload.callback({ type: 0, message, data: err?.response?.data });
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* updateCMSUserRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updateCMSUser, payload);
    action.payload.callback(response);
  } catch (err) {
    const message = getServerMessage(err, "Failed to update user details");
        if (typeof action?.payload?.callback === "function") {
      action.payload.callback({ type: 0, message, data: err?.response?.data });
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deleteCMSUserRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteCMSUser, payload);
    action.payload.callback(response);
  } catch (err) {
    const message = getServerMessage(err, "Failed to delete user");
        if (typeof action?.payload?.callback === "function") {
      action.payload.callback({ type: 0, message, data: err?.response?.data });
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* setAdminUserPasswordRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.setAdminUserPassword, payload);
    const isSuccess =
      String(response?.type) === "1" ||
      /success/i.test(response?.message || "") ||
      /success/i.test(response?.data?.[0] || "");
    const normalizedResponse = {
      ...response,
      type: isSuccess ? 1 : 0,
    };

    yield put({
      type: actionTypes.SET_ADMIN_USER_PASSWORD_SUCCESS,
      payload: normalizedResponse,
    });

    if (typeof action?.payload?.callback === "function") {
      action.payload.callback(normalizedResponse);
    }
  } catch (err) {
    const message = getServerMessage(err, "Failed to update password");

    yield put({
      type: actionTypes.SET_ADMIN_USER_PASSWORD_FAIL,
      payload: message,
    });

    if (typeof action?.payload?.callback === "function") {
      action.payload.callback({ type: 0, message, data: err?.response?.data });
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* resyncUserAuth0ProfileRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.resyncUserAuth0Profile, payload);
    const normalizedResponse = {
      ...response,
      type: String(response?.type) === "1" ? 1 : 0,
    };

    yield put({
      type: actionTypes.RESYNC_USER_AUTH0_PROFILE_SUCCESS,
      payload: normalizedResponse,
    });

    if (typeof action?.payload?.callback === "function") {
      action.payload.callback(normalizedResponse);
    }
  } catch (err) {
    const message = getServerMessage(err, "Failed to sync user from Auth0");

    yield put({
      type: actionTypes.RESYNC_USER_AUTH0_PROFILE_FAIL,
      payload: message,
    });

    if (typeof action?.payload?.callback === "function") {
      action.payload.callback({ type: 0, message, data: err?.response?.data });
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* lookupCMSUserByEmailRequestSaga(action) {
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.lookupCMSUserByEmail, payload);
    const normalizedResponse = {
      ...response,
      type: String(response?.type) === "1" ? 1 : 0,
    };

    yield put({
      type: actionTypes.LOOKUP_CMS_USER_BY_EMAIL_SUCCESS,
      payload: normalizedResponse,
    });

    if (typeof action?.payload?.callback === "function") {
      action.payload.callback(normalizedResponse);
    }
  } catch (err) {
    const message = getServerMessage(err, "Failed to lookup user by email");

    yield put({
      type: actionTypes.LOOKUP_CMS_USER_BY_EMAIL_FAIL,
      payload: message,
    });

    if (typeof action?.payload?.callback === "function") {
      action.payload.callback({ type: 0, message, data: err?.response?.data });
    }
  }
}

function* availableUsersRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback } = action.payload || {};


    const response = yield call(api.getAvailableUsers);

    yield put({
      type: actionTypes.AVAILABLE_USERS_SUCCESS,
      payload: response,
    });

    if (typeof callback === "function") {
      callback({
        type: 1,
        data: response?.data?.[0]?.matchingUsers || [],
      });
    }
  } catch (err) {
    const message = err?.response?.data?.errors?.[0]?.message || err?.message;


    yield put({
      type: actionTypes.AVAILABLE_USERS_FAIL,
      payload: message,
    });

    if (typeof action.payload?.callback === "function") {
      action.payload.callback({ type: 0, error: message });
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}
function* saveUserCircleRequestSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));

    try {
      const { payload } = action;
      const { callback } = payload;

      const response = yield call(api.saveUserCircleAPI, payload);

      yield put({
        type: actionTypes.SAVE_USER_CIRCLE_SUCCESS,
        payload: response,
      });

      if (typeof callback === "function") {
        callback({ type: 1, data: response });
      }
    } catch (err) {
      const message = err?.response?.data?.errors?.[0]?.message || err.message;

      yield put({
        type: actionTypes.SAVE_USER_CIRCLE_FAIL,
        payload: message,
      });

      if (typeof action.payload?.callback === "function") {
        action.payload.callback({ type: 0, error: message });
      }
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }

  function* myCircleRequestsSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));

    try {
      const { callback } = action.payload || {};

      const response = yield call(api.getMyCircleRequestsAPI, action.payload);

      yield put({
        type: actionTypes.MY_CIRCLE_REQUESTS_SUCCESS,
        payload: response,
      });

      callback?.({ type: 1, data: response.data });
    } catch (err) {
      const message =
        err?.response?.data?.errors?.[0]?.message || err.message;

      yield put({
        type: actionTypes.MY_CIRCLE_REQUESTS_FAIL,
        payload: message,
      });

      action.payload?.callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* updateUserCircleSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));

    try {
      const { callback, ...apiPayload } = action.payload;


      const response = yield call(api.updateUserCircleAPI, apiPayload);

      yield put({
        type: actionTypes.UPDATE_USER_CIRCLE_SUCCESS,
        payload: response,
      });

      callback?.({ type: 1, data: response });
    } catch (err) {
      const message =
        err?.response?.data?.errors?.[0]?.message || err.message;


      yield put({
        type: actionTypes.UPDATE_USER_CIRCLE_FAIL,
        payload: message,
      });

      action.payload?.callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* myCircleListSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));

    try {
      const { callback, ...payload } = action.payload || {};


      const response = yield call(api.getMyCircleAPI, payload);

      yield put({
        type: actionTypes.MY_CIRCLE_LIST_SUCCESS,
        payload: response,
      });

      callback?.({ type: 1, data: response.data });
    } catch (err) {
      const message =
        err?.response?.data?.errors?.[0]?.message || err.message;


      yield put({
        type: actionTypes.MY_CIRCLE_LIST_FAIL,
        payload: message,
      });

      action.payload?.callback?.({ type: 0, error: message });
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* getChurchUsersSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));

    try {
      const { callback, ...apiPayload } = action.payload || {};


      const response = yield call(api.getChurchUsersAPI, apiPayload);

      yield put({
        type: actionTypes.GET_CHURCH_USERS_SUCCESS,
        payload: response,
      });

      if (typeof callback === "function") {
        callback({
          type: 1,
          data: response?.data || [],
        });
      }
    } catch (err) {
      const message = err?.response?.data?.errors?.[0]?.message || err?.message;


      yield put({
        type: actionTypes.GET_CHURCH_USERS_FAIL,
        payload: message,
      });

      if (typeof action.payload?.callback === "function") {
        action.payload.callback({ type: 0, error: message });
      }
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* getNotificationsSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));

    try {
      const { callback, ...apiPayload } = action.payload || {};


      const response = yield call(api.getNotificationsAPI, apiPayload);

      yield put({
        type: actionTypes.GET_NOTIFICATIONS_SUCCESS,
        payload: response,
      });

      if (typeof callback === "function") {
        callback({
          type: 1,
          data: response?.data || [],
        });
      }
    } catch (err) {
      const message = err?.response?.data?.errors?.[0]?.message || err?.message;


      yield put({
        type: actionTypes.GET_NOTIFICATIONS_FAIL,
        payload: message,
      });

      if (typeof action.payload?.callback === "function") {
        action.payload.callback({ type: 0, error: message });
      }
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
  function* sendNotificationToOneSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));

    try {
      const { callback, ...apiPayload } = action.payload || {};


      const response = yield call(api.sendNotificationToOneAPI, apiPayload);


      // Check the response type
      if (response.type === 1) {
        yield put({
          type: actionTypes.SEND_NOTIFICATION_TO_ONE_SUCCESS,
          payload: response,
        });

        if (typeof callback === "function") {
          callback({
            type: 1,
            data: response?.data || {},
            message: response?.message || "Notification sent successfully",
          });
        }
      } else {
        // Handle API returning error type
        const errorMessage = response?.data?.[0] || response?.message || "Failed to send notification";

        yield put({
          type: actionTypes.SEND_NOTIFICATION_TO_ONE_FAIL,
          payload: errorMessage,
        });

        if (typeof callback === "function") {
          callback({
            type: 0,
            error: errorMessage,
          });
        }
      }
    } catch (err) {

      let errorMessage = "Failed to send notification";

      if (err?.response?.data) {
        // Handle different error response formats
        if (err.response.data.errors && err.response.data.errors[0]) {
          errorMessage = err.response.data.errors[0].message;
        } else if (err.response.data.data && Array.isArray(err.response.data.data)) {
          errorMessage = err.response.data.data[0];
        } else if (err.response.data.message) {
          errorMessage = err.response.data.message;
        }
      } else if (err?.message) {
        errorMessage = err.message;
      }

      yield put({
        type: actionTypes.SEND_NOTIFICATION_TO_ONE_FAIL,
        payload: errorMessage,
      });

      if (typeof action.payload?.callback === "function") {
        action.payload.callback({
          type: 0,
          error: errorMessage,
        });
      }
    } finally {
      yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
  }
export default function* UsersWatcherSaga() {
  yield takeLatest(actionTypes.GET_ROLES_REQUEST, getRolesRequestSaga);

  yield takeLatest(actionTypes.SAVE_CMS_USER_REQUEST, saveCMSUserRequestSaga);

  yield takeEvery(actionTypes.GET_CMS_USER_REQUEST, getCMSUserRequestSaga);

  yield takeLatest(actionTypes.UPDATE_CMS_USER_REQUEST, updateCMSUserRequestSaga);
  yield takeLatest(actionTypes.DELETE_CMS_USER_REQUEST, deleteCMSUserRequestSaga);
  yield takeLatest(
    actionTypes.SET_ADMIN_USER_PASSWORD_REQUEST,
    setAdminUserPasswordRequestSaga
  );
  yield takeLatest(
    actionTypes.RESYNC_USER_AUTH0_PROFILE_REQUEST,
    resyncUserAuth0ProfileRequestSaga
  );
  yield takeLatest(
    actionTypes.LOOKUP_CMS_USER_BY_EMAIL_REQUEST,
    lookupCMSUserByEmailRequestSaga
  );
  yield takeLatest(
    actionTypes.AVAILABLE_USERS_REQUEST,
    availableUsersRequestSaga
  );
  yield takeLatest(
    actionTypes.SAVE_USER_CIRCLE_REQUEST,
    saveUserCircleRequestSaga
  );
  yield takeLatest(
    actionTypes.MY_CIRCLE_REQUESTS_REQUEST,
    myCircleRequestsSaga
  );
  yield takeLatest(
    actionTypes.UPDATE_USER_CIRCLE_REQUEST,
    updateUserCircleSaga
  );
  yield takeLatest(
    actionTypes.MY_CIRCLE_LIST_REQUEST,
    myCircleListSaga
  );
  yield takeLatest(actionTypes.GET_CHURCH_USERS_REQUEST, getChurchUsersSaga);
  yield takeLatest(actionTypes.GET_NOTIFICATIONS_REQUEST, getNotificationsSaga);
  yield takeLatest(
    actionTypes.SEND_NOTIFICATION_TO_ONE_REQUEST,
    sendNotificationToOneSaga
  );

}
